var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupportIcon = function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#support-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 89.62c20.553 0 37.215-16.662 37.215-37.215S80.553 15.19 60 15.19 22.785 31.852 22.785 52.405 39.447 89.62 60 89.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M60 89.24c20.344 0 36.835-16.491 36.835-36.835S80.344 15.57 60 15.57 23.165 32.06 23.165 52.405 39.656 89.24 60 89.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#support-icon_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M69.969 53.166 60 63.038l-9.968-9.872A6.645 6.645 0 1 1 60 44.439a6.643 6.643 0 0 1 9.692-1.005 6.645 6.645 0 0 1 .277 9.74M60 44.43l-4.376 4.376a1.33 1.33 0 0 0 0 1.88l.721.721a2.35 2.35 0 0 0 3.323 0l1.33-1.329a4.23 4.23 0 0 1 5.98 0l2.99 2.99m-9.303 3.988 2.658 2.658m.665-5.98 2.658 2.657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "support-icon_svg__c",
    x1: 71.957,
    x2: 46.708,
    y1: 63.038,
    y2: 43.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "support-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "support-icon_svg__b",
    width: 134.671,
    height: 134.671,
    x: -7.335,
    y: -4.93,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_149",
    result: "shape"
  })))));
};
export default SvgSupportIcon;